module.exports = __webpack_public_path__ + "23fea88a87af01d366e05a5f9fae2e7f.svg";